module.exports = __webpack_public_path__ + "static/media/12_crisalide.9cda64e3.jpg";